import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetFormDataField } from 'cng-common/features/form'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../configs'
import { ApplicableToggle } from '../../applicableToggle/ApplicableToggle'

import { WarehousesEditMode } from './components/warehousesEditMode/WarehousesEditMode'
import { WarehousesReadMode } from './components/warehousesReadMode/WarehousesReadMode'

import styles from './Warehouses.module.scss'

interface IWarehousesProps {
  isApplicable: boolean
  count: Nullable<number>
  locations: string
}

export const Warehouses: FC<IWarehousesProps> = ({
  isApplicable: initialApplicableValue,
  locations,
  count,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  const [formApplicableValue] = useGetFormDataField<boolean>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.warehouseIsApplicable
  )

  const isApplicableValue = useMemo(
    () => (isEditMode ? formApplicableValue : initialApplicableValue),
    [isEditMode, formApplicableValue, initialApplicableValue]
  )

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        <div className={styles.labelWrapper}>
          <span className={styles.sectionIcon} aria-hidden="true">
            <i className="kbase kbase-home" />
          </span>
          <FieldLabel labelTranslation="partnerbasicinfo-warehouse" />
        </div>
        {isEditMode && (
          <ApplicableToggle
            containerClassName={styles.applicableWrapper}
            isEditMode={isEditMode}
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.warehouseIsApplicable}
            defaultValue={initialApplicableValue}
          />
        )}
      </div>
      {!isEditMode && (
        <WarehousesReadMode
          isApplicable={initialApplicableValue}
          count={count}
          locations={locations}
        />
      )}
      {isEditMode && (
        <WarehousesEditMode count={count} locations={locations} isApplicable={isApplicableValue} />
      )}
    </div>
  )
}
